import { render, staticRenderFns } from "./GenreMain.vue?vue&type=template&id=043215d5&scoped=true"
import script from "./GenreMain.vue?vue&type=script&lang=js"
export * from "./GenreMain.vue?vue&type=script&lang=js"
import style0 from "./GenreMain.vue?vue&type=style&index=0&id=043215d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043215d5",
  null
  
)

export default component.exports